import { useState } from 'react';
// import { useNavigate } from "react-router-dom";
// import styled from "styled-components";

const Home = () => {
  // const navigate = useNavigate();

  useState(() => {
    console.log('현재 모드 : ', process.env.REACT_APP_MODE);
  }, []);

  return (
    <></>
    // <Container>
    //   <h1>🏠 홈 페이지입니다</h1>
    //   <StyledButton onClick={() => navigate("/about")}>
    //     About 페이지로 이동
    //   </StyledButton>
    // </Container>
  );
};

export default Home;

// const Container = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   margin-top: 100px;
// `;

// const StyledButton = styled.button`
//   background-color: #0077ff;
//   color: white;
//   border: none;
//   padding: 12px 24px;
//   font-size: 16px;
//   border-radius: 10px;
//   cursor: pointer;
//   transition: all 0.2s ease;

//   &:hover {
//     background-color: #005edb;
//     transform: scale(1.05);
//   }
// `;
